import React, { useEffect, useRef } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { connect, useSelector } from "react-redux";
import { userOperations } from "../../state/features/user";
import { errorOperations } from "../../state/features/error";

interface IMarketingConsentMobileProps {
  updateMarketingConsent: (consent: boolean, csrfToken: string) => void;
  updateError: (error: any) => void;
}
const MarketingConsentMobile = ({
  updateMarketingConsent,
  updateError,
}: IMarketingConsentMobileProps) => {
  const intl = useIntl();
  const checkBoxRef = useRef<HTMLInputElement>(null);
  const { marketing_consent = false } = useSelector(
    (state: any) => state.user?.metadata
  );

  useEffect(() => {
    if (checkBoxRef.current) {
      checkBoxRef.current.checked = marketing_consent;
    }
  }, [marketing_consent]);

  const toggleMarketingConsent = async () => {
    const csrfToken = document.querySelector("[name=csrf-token]")?.content;
    try {
      const isChecked = checkBoxRef.current?.checked ?? false;
      await updateMarketingConsent(isChecked, csrfToken);
    } catch (error) {
      updateError({
        title: intl.formatMessage({ id: "error.oops" }),
        message: intl.formatMessage({ id: "error.something_went_wrong" }),
      });
    }
  };

  return (
    <div className="d-flex">
      <input
        type="checkbox"
        onChange={toggleMarketingConsent}
        ref={checkBoxRef}
      />
      <label className="mx-2">
        <FormattedMessage id="my_account.marketing_consent" />
      </label>
    </div>
  );
};

const mapDispatchToProps = {
  updateMarketingConsent: userOperations.updateMarketingConsent,
  updateError: errorOperations.updateError,
};

export default connect(null, mapDispatchToProps)(MarketingConsentMobile);
